import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api/selectitem';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { FormValidation, HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { InicioObraDTO, InputReporte, OutputReporteInicioObra, OutputVistaInformacionGeneral, SeguridadSalida } from 'src/app/modelo';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-inicio-obra',
    templateUrl: './inicio-obra.component.html',
    //styleUrls: ['./inicio-obra.component.css']
})
export class InicioObraComponent implements OnInit {


    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public inicioObra: OutputReporteInicioObra;
    public entity: InicioObraDTO;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;

    //Validaciones

    public observacionBitacoraObra_MensajeError: FormValidation = new FormValidation(null);
    public observacionPruebas_MensajeError: FormValidation = new FormValidation(null);
    public indicadorCalidad_MensajeError: FormValidation = new FormValidation(null);
    public minDate: Date;
    public maxDate: Date;



    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        this.setMinMaxDate();

    }

    private setMinMaxDate(): void {

        let fecha: Date = new Date();

        fecha.setDate(fecha.getDate() - 15);

        this.minDate = fecha;

        this.maxDate = new Date();
    }

    /**
    * 
    */
    async ngOnInit() {
        this.inicioObra = <OutputReporteInicioObra>{ listaInicioObra: [] };
    }

    /**
     * 
     */
    public async init() {
        await this.loading();
    }

    /**
     * 
     */
    public getSelectItem(): SelectItem[] {

        let lista: SelectItem[] = [];

        if (this.inicioObra != null && this.inicioObra.listCatalogoNivel != null) {

            for (let row of this.inicioObra.listCatalogoNivel) {
                lista.push({ label: row.descripcion, value: row.idNivel });
            }

        }

        return lista;
    }

    /**
     * 
     */
    public async loading() {

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteInicioObra> = await this.service.ObtenerReporteInicioObra(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.inicioObra = resultado.model;

            if (this.inicioObra.fecha1aVisita != null) {
                this.inicioObra.fecha1aVisita = new Date(this.inicioObra.fecha1aVisita);
            }

            if (this.inicioObra.listaInicioObra != null && this.inicioObra.listaInicioObra.length > 0) {

                this.entity = this.inicioObra.listaInicioObra[0];

                this.inicioObra.porcentajeAvanceUrbanizacion_TMP = this.inicioObra.porcentajeAvanceUrbanizacion;
                this.inicioObra.porcentajeAvanceInfraestructura_TMP = this.inicioObra.porcentajeAvanceInfraestructura;
                this.inicioObra.porcentajeAvanceEquipamiento_TMP = this.inicioObra.porcentajeAvanceEquipamiento;
                this.inicioObra.cumpleBitacoraObra_TMP = this.inicioObra.cumpleBitacoraObra;
                this.inicioObra.cumplePruebas_TMP = this.inicioObra.cumplePruebas;

                // Copiar valor propiedad

                for (let inicioObra of this.inicioObra.listaInicioObra) {
                    inicioObra.criterioSinInicioObra_TMP = inicioObra.criterioSinInicioObra;
                    inicioObra.indicadorCalidad_TMP = inicioObra.indicadorCalidad;
                    this.inicioObra.claveEstatus = inicioObra.claveEstatus;
                }

            }

            this.onChangeListaPorcentajeObraEjecutada();

            this.setContadorCriterios();

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }
    }

    /**
     * 
     */
    private onChangeListaPorcentajeObraEjecutada(): void {

        //Set Lista ( Porcentaje de obra ejecutada )

        if (this.inicioObra != null && this.inicioObra.listaInicioObra != null) {

            for (let row of this.inicioObra.listaInicioObra) {

                row.listaPorcentajeObraEjecutada = [];

                if (row.criterioSinInicioObra != 2) {

                    switch (row.criterioSinInicioObra) {

                        case 1:
                            {
                                for (let x = 1; x <= this.inicioObra.parametrosPorcentajeObraEjecutada.cumple; x++) {
                                    row.listaPorcentajeObraEjecutada.push({ label: x + '', value: x })
                                }
                            }
                            break;

                        case 0:
                            {
                                {
                                    for (let x = this.inicioObra.parametrosPorcentajeObraEjecutada.noCumple; x <= 100; x++) {
                                        row.listaPorcentajeObraEjecutada.push({ label: x + '', value: x })
                                    }
                                }
                            }
                            break;
                    }

                }

            }

        }

    }

    /**
     * 
     * @param idEdificio
     * @param value
     */
    private onChangeCriterio(idEdificio: number | null, value: number): void {

        if (this.inicioObra != null && this.inicioObra.listaInicioObra != null && idEdificio != null) {

            let lista = this.inicioObra.listaInicioObra.filter(row => row.idEdificio == idEdificio);

            if (lista != null) {

                for (let row of lista) {
                    row.criterioSinInicioObra = value;
                }
            }

        }

    }

    /**
     * 
     */
    private setContadorCriterios(): void {

        if (this.inicioObra != null && this.inicioObra.listaInicioObra != null) {
            let listaPendientes = this.inicioObra.listaInicioObra.filter(row => row.criterioSinInicioObra == 2);
            let listaCumple = this.inicioObra.listaInicioObra.filter(row => row.criterioSinInicioObra == 1);
            let listaNoCumple = this.inicioObra.listaInicioObra.filter(row => row.criterioSinInicioObra == 0);
            this.inicioObra.pendientes = listaPendientes.length;
            this.inicioObra.cumple = listaCumple.length;
            this.inicioObra.noCumple = listaNoCumple.length;
        }
    }

    /**
    * 
    * @param entity
    */
    public onRowSelect(entity: any): void {

        let idVivienda = entity.data.indentificadorVivienda;

        let object: InicioObraDTO = this.inicioObra.listaInicioObra.filter(row => row.indentificadorVivienda == idVivienda)[0];

        this.entity = object;
    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
    * 
    */
    public Salir(): void {
        HttpSession.clear();
        Util.forward(this._router, 'Login');
    }

    /**
     * 
     * @param value
     */
    public onChangeBitacoraObra(value: boolean): void {
        this.inicioObra.cumpleBitacoraObra = value;
        this.observacionBitacoraObra_MensajeError = new FormValidation(null);
        this.actualizarErrores('observacionesBitacoraObra');
    }

    /**
     * 
     * @param value
     */
    public onChangePruebas(value: boolean): void {
        this.inicioObra.cumplePruebas = value;
        this.observacionPruebas_MensajeError = new FormValidation(null);
        this.actualizarErrores('observacionesPruebas');
    }

    /**
    * 
    */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
    * 
    */
    public validarFormumlario(): boolean {

        var error = false;

        if (!this.inicioObra.cumpleBitacoraObra) {

            this.observacionBitacoraObra_MensajeError = new FormValidation(this.inicioObra.observacionesBitacoraObra).requered('La Observacion es obligatorio.');

            if (this.observacionBitacoraObra_MensajeError.error) {
                error = true;
            }

        }

        if (!this.inicioObra.cumplePruebas) {

            this.observacionPruebas_MensajeError = new FormValidation(this.inicioObra.observacionesPruebas).requered('La Observacion es obligatorio.');

            if (this.observacionPruebas_MensajeError.error) {
                error = true;
            }

        }

        //{
        //    let cont: number = 0;

        //    if (this.inicioObra != null && this.inicioObra.listaInicioObra != null) {

        //        let filter = this.inicioObra.listaInicioObra.filter(row => row.criterioSinInicioObra == 2);

        //        if (filter != null) {
        //            cont = filter.length;
        //        }

        //        if (cont == 0) {

        //            let filter = this.inicioObra.listaInicioObra.filter(row => row.indicadorCalidad == 2);

        //            if (filter != null) {
        //                cont = filter.length;
        //            }

        //            if (cont > 0) {
        //                this.indicadorCalidad_MensajeError = new FormValidation(null).requered('Faltan por capturar Indicador(s) de calidad.');
        //                error = true;
        //            }

        //        }

        //    }
        //}

        return error;
    }

    /**
     * 
     * @param tipo
     */
    public actualizarErrores(tipo: string) {

        switch (tipo) {

            case 'observacionesBitacoraObra':

                if (!this.inicioObra.cumpleBitacoraObra) {
                    this.observacionBitacoraObra_MensajeError = new FormValidation(this.inicioObra.observacionesBitacoraObra).requered('La Observacion es obligatorio.');
                }

                break;

            case 'observacionesPruebas':

                if (!this.inicioObra.cumplePruebas) {
                    this.observacionPruebas_MensajeError = new FormValidation(this.inicioObra.observacionesPruebas).requered('La Observacion es obligatorio.');
                }

                break;
        }

    }

    /**
     * 
     */
    public async Guardar() {

        if (!this.validarFormumlario()) {

            Util.showLoadingMessage(this.spinner, `Guardando información de reporte inio de obra ...`);

            let resultado: JsonResponse<boolean> = await this.service.GuardarReporteInicioObra(this.inicioObra).toPromise();

            Util.hideLoadingMessage();

            if (resultado != null && resultado.code == 200) {
                
                var strCallback = (): void => {
                    this.Regresar();
                }

                let value = Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success', false, strCallback);

                //this.disabledButton = false;

                let cont: number = this.validacion(false);

                if (cont == 0) {
                    //this.disabledButton = true;
                }

                console.warn('WEB SERVICE -->> ', resultado);

            } else {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
                console.error('Guardar() -->> ', resultado.message);
            }

        } else {
            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Favor de capturar los valores solicitados...', 'warning');
        }

    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeIndicadorCalidad(entity: InicioObraDTO, value: number) {
        entity.indicadorCalidad = value;
    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeCriterioSinInicioObra(entity: InicioObraDTO, value: number) {

        if (entity.verCSIO == true) {
            entity.criterioSinInicioObra = value;
            this.onChangeCriterio(entity.idEdificio, value);
        }

        if (value == 2) {
            entity.porcentajeObraEjecutada = 0;
        }

        this.onChangeListaPorcentajeObraEjecutada();
        this.setContadorCriterios();
        this.validacion(true);
    }

    /**
     * 
     * @param mensaje
     */
    private validacion(mensaje: boolean): number {

        let cont: number = 0;

        if (this.inicioObra != null && this.inicioObra.listaInicioObra != null) {

            let filter = this.inicioObra.listaInicioObra.filter(row => row.criterioSinInicioObra == 2);

            if (filter != null) {
                cont = filter.length;
            }

            if (cont == 0 && mensaje == true) {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Calificación Terminada...', 'success');
            }

        }

        return cont;
    }

    /**
     * 
     **/
    public getDateSpanish(): any {
        return Util.getDateSpanish();
    }

    /**
     * 
     * @param idNivelIncumplimiento
     */
    public getNivelIncumplimiento(idNivelIncumplimiento: number): string {

        let resultado: string = '';

        if (this.inicioObra != null && this.inicioObra.listCatalogoNivel != null) {

            let filter = this.inicioObra.listCatalogoNivel.filter(row => row.idNivel == idNivelIncumplimiento);

            if (filter != null && filter.length > 0) {
                resultado = filter[0].descripcion;
            }

        }

        return resultado;

    }

    /**
    * 
    * @param index
    */
    public getListPorcentaje(index: number): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let x = index; x <= 100; x++) {
            lista.push({ label: x + '', value: x })
        }

        return lista;
    }

    /**
     * 
     * @param entity
     * @param idOpcion
     */
    public getDisabled(entity: InicioObraDTO, idOpcion: number | null): boolean {

        let resultado: boolean = false;

        if (this.inicioObra.claveEstatus != 0) {
            resultado = true;
        }

        if (entity != null) {

            if (idOpcion != null) {

                switch (idOpcion) {

                    case 1:
                        {
                            if (entity.criterioSinInicioObra_TMP == 1) {
                                resultado = true;
                            }
                        }
                        break;
                    case 2:
                        {
                            if (entity.indicadorCalidad_TMP == 1) {
                                resultado = true;
                            }
                        }
                        break;
                }
            }

        } else {


            switch (idOpcion) {

                case 1:
                    {
                        if (this.inicioObra.fecha1aVisita == null) {
                            resultado = true;
                        }

                        if (this.inicioObra.cumpleBitacoraObra_TMP == true) {
                            resultado = true;
                        }
                    }
                    break;
                case 2:
                    {
                        if (this.inicioObra.fecha1aVisita == null) {
                            resultado = true;
                        }

                        if (this.inicioObra.cumplePruebas_TMP == true) {
                            resultado = true;
                        }
                    }
                    break;
            }

        }

        return resultado;
    }

    /**
     * 
     */
    public getDisabledFecha1aVisita(): boolean {

        let resultado: boolean = false;

        if (this.inicioObra.claveEstatus != 0) {
            resultado = true;
        }

        if (this.inicioObra.fecha1aVisita == null) {
            resultado = true;
        }

        return resultado;
    }

}
